// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CreateBreederBinding, CreateBreederBindingSchema } from 'api/gen/CreateBreederBinding';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateBreederBindingAdminBaseObject, ValidateBreederBindingAdminBaseObjectSchema } from 'api/gen/ValidateBreederBindingAdminBaseObject';

const requiredPart = t.interface({
  tag: t.literal('ValidateCreateBreederBindingAdmin'),
  binding: t.union([CreateBreederBindingSchema, t.null]),
});

export const ValidateCreateBreederBindingAdminSchema = excess(t.intersection([ValidateBreederBindingAdminBaseObjectSchema.type, requiredPart]));

export interface ValidateCreateBreederBindingAdmin extends t.TypeOf<typeof ValidateCreateBreederBindingAdminSchema> {}
